<template>
  <div class="baseContent-warp">
    <Card>
      <div slot="title" class="header font-hua">
        <h3>
          <span v-show="titleShow == 0">{{ examTemplateName }}</span>
          <el-input v-show="titleShow == 1" class="title-input" v-model="examTemplateName"
            @keyup.enter="modifyTitle('save')" />
        </h3>
        <el-button class="edit" icon="el-icon-edit" v-show="titleShow == 0" @click="titleShow = 1" type="text" />
        <el-button class="edit" icon="el-icon-check" v-show="titleShow == 1" @click="modifyTitle('save')" type="text" />
        <el-button class="edit" icon="el-icon-close" v-show="titleShow == 1" @click="modifyTitle('cancel')" type="text" />
      </div>
      <div slot="btn">
        <el-button icon="el-icon-back" class="r90"
          @click="$router.push('/patientfollowup/questionnairelist')">列表</el-button>
        <el-button icon="el-icon-refresh" @click="$refresh(getQuestionsList)">刷新</el-button>
      </div>
      <div slot="content" class="detailswrap">
        <!-- 操作按钮 -->
        <div class="button">
          <el-button icon="el-icon-plus" type="primary" @click="addQuestions">新增题目</el-button>
          <el-button icon="el-icon-delete" type="danger" @click="deleteQuestionsList">批量删除</el-button>
        </div>
        <div>
          <!-- 题目列表 -->
          <el-table v-loading="loading" :data="questionsList" :max-height="tableHeight" ref="multipleTable"
            @selection-change="val => $handleSelectionChange(val, true)">
            <el-table-column type="selection" width="50" />
            <el-table-column type="expand" width="30">
              <template slot-scope="props">
                <el-form label-position="right">
                  <el-form-item label="题目名称"><span>{{ props.row.questionsTitle }}</span></el-form-item>
                  <el-form-item label="题目类型"><span>{{ props.row.questionsType }}</span></el-form-item>
                  <el-form-item class="option" label="题目选项" v-if="props.row.questionsType != '简答'">
                    <div v-for="(item, i) in props.row.templateAnswers" :key="item.examTemplateAnswerId">
                      {{ i + 1 }}. {{ item.answerContent }}
                    </div>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column prop="questionsTitle" label="题目名称" />
            <el-table-column prop="questionsType" label="题目类型" />
            <el-table-column prop="createBy" label="创建人" />
            <el-table-column prop="createTime" label="创建时间" min-width="150" />
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button icon="el-icon-edit" type="primary" @click="editQuestions(scope.row)">编辑</el-button>
                <el-button icon="el-icon-delete" type="danger" @click="deleteQuestions(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getQuestionsList)"
            :total="total" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
        </div>
        <!-- 编辑弹框 -->
        <el-dialog class="questionsEdit" title="编辑题目" :visible.sync="dialogVisible" width="500px"
          :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" label-width="80px" :rules="editFormRules" inline>
            <el-form-item label="题目名称" prop="questionsTitle">
              <el-input v-model="editForm.questionsTitle" placeholder="请输入题目名称" />
            </el-form-item>
            <el-form-item label="题目类型" prop="questionsType">
              <el-radio-group v-model="editForm.questionsType" @change="val => setOption(val, editForm)">
                <el-radio label="单选" />
                <el-radio label="多选" />
                <el-radio label="简答" />
              </el-radio-group>
            </el-form-item>
            <el-form-item class="option" label="题目选项" prop="templateAnswers" v-if="editForm.questionsType != '简答'">
              <div class="option-wrap">
                <el-form-item v-for="(item, i) in editForm.templateAnswers" :key="i" :label="'选项' + (i + 1)"
                  :prop="'templateAnswers.' + i + '.answerContent'"
                  :rules="[{ required: true, message: '选项内容不能为空！', trigger: 'blur' }]">
                  <el-input v-model="item.answerContent" placeholder="请输入选项内容" />
                  <el-button icon="el-icon-delete" type="danger" @click="delAnswer(i)" />
                </el-form-item>
              </div>
              <el-button icon="el-icon-plus" type="primary" @click="addOption">新建选项</el-button>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="editSave(editForm)">保存修改</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 新建弹框 -->
        <el-dialog class="questionsAdd" title="新增问卷题目" :visible.sync="addVisible" width="600px"
          :before-close="done => $handleClose(done, 'addForm')" :close-on-click-modal="false">
          <el-form :model="addForm" ref="addForm" label-width="80px" inline>
            <el-form-item label="题库题目" prop="examQuestionBankIds" :rules="[{ required: true, message: '选择的题目不能为空！' }]">
              <el-select v-model="addForm.examQuestionBankIds" multiple clearable>
                <el-option v-for="item in questionOptions" :key="item.examQuestionBankId" :label="item.questionsTitle"
                  :value="item.examQuestionBankId" />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="addSave(addForm)">保存题目</el-button>
            <el-button @click="$cancel('addVisible', 'addForm')">取 消</el-button>
          </span>
        </el-dialog>

      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { questionList, questionEdit, questionDelete, questionAdd, questionBankList, templateEdit } from "@/api/followup-questionnaire"; // 获取问卷请求
export default {
  name: "templates",
  data() {
    return {
      loading: true, // 加载中
      examTemplateId: this.$route.query.examTemplateId, // 随访问卷id
      examTemplateName: this.$route.query.examTemplateName, // 随访问卷标题
      questionsList: [], // 题目列表
      multipleSelection: [], // 被选中行
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        questionsTitle: [{ required: true, message: "题目名称不能为空！" }],
        questionsType: [{ required: true }],
        templateAnswers: [{ required: true }]
      }, // 验证规则
      questionOptions: [], // 题库问题
      addVisible: false, // 添加弹框
      addForm: {}, // 添加题目对象
      titleShow: 0, // 标题是否修改 
      tableHeight: 0, // 表格最大高度
      searchForm: {}
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280; // 计算表格最大高度
    this.getQuestionsList(); // 请求题目列表
    this.getQuestionBankList(); // 请求题库
  },
  methods: {
    // 请求所有题目列表
    async getQuestionsList() {
      let { rows, code, total } = await questionList({ pageNum: this.currentPage, pageSize: this.pageSize, examTemplateId: this.examTemplateId });
      if (code == 200) {
        rows.forEach(item => {
          switch (item.questionsType) {
            case '0': item.questionsType = '单选'; break;
            case '1': item.questionsType = '多选'; break;
            case '2': item.questionsType = '简答'; break;
          }
        });
        this.questionsList = rows;
        this.total = total;
      }
      this.loading = false;
    },
    // 请求题库
    async getQuestionBankList() {
      let { rows, code } = await questionBankList();
      if (code == 200) this.questionOptions = rows;
    },
    // 修改问卷题目
    async modifyTitle(type) {
      if (type == 'save') {
        if (this.examTemplateName == "") this.$message.error('问卷标题不能为空，请修改后再试！');
        else {
          let { code } = await templateEdit({ examTemplateId: this.examTemplateId, examTemplateName: this.examTemplateName });
          if (code == 200) {
            this.$message.success('修改问卷标题成功！');
            this.titleShow = 0;
          }
        }
      }
      this.titleShow = 0;
    },
    // 新增选项
    addOption() {
      this.editForm.templateAnswers.push({ answerContent: null });
    },
    // 删除选项
    delAnswer(i) {
      let list = this.editForm.templateAnswers;
      if (list.length == 1) this.$message('最后一项不能删除！');
      else list.forEach((item, index) => {
        if (index == i) list.splice(index, 1)
      })
    },
    // 切换题目类型如果不是简单添加选项
    setOption(val, obj) {
      if (val != '简答' && obj.templateAnswers.length == 0) {
        obj.templateAnswers = [{ answerContent: null }];
      }
    },
    // 新增题目
    addQuestions() {
      this.addVisible = true;
      this.addForm = { examQuestionBankIds: null };
    },
    // 保存新增
    addSave(obj) {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let params = [];
          this.questionOptions.forEach(item => {
            obj.examQuestionBankIds.forEach(kid => {
              if (kid == item.examQuestionBankId) {
                params.push({
                  questionsTitle: item.questionsTitle, questionsType: item.questionsType,
                  examTemplateId: this.examTemplateId, templateAnswers: item.answers
                });
              }
            });
          });
          questionAdd(params).then(res => {
            if (res.code == 200) this.$message.success("新增题目成功！");

            this.addVisible = false;
            this.$refresh(this.getQuestionsList);
            this.$refs['addForm'].resetFields();
          });
        } else return false;
      })
    },
    // 编辑题目信息
    editQuestions(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    // 保存题目修改
    editSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          switch (obj.questionsType) {
            case '单选': obj.questionsType = '0'; break;
            case '多选': obj.questionsType = '1'; break;
            case '简答': obj.questionsType = '2'; obj.templateAnswers = []; break;
          }
          questionEdit(obj).then(res => {
            if (res.code == 200) this.$message.success("修改题目成功！");
            this.dialogVisible = false;
            this.$refresh(this.getQuestionsList);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 删除题目
    deleteQuestions(row) {
      this.$confirm('确认删除该题目？').then(_ => { this.del(row.examTemplateQuestionsId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await questionDelete(id);
      if (code == 200) this.$message.success("删除题目成功！");
      this.$refresh(this.getQuestionsList);
    },
    // 批量删除题目
    deleteQuestionsList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何题目");
      else {
        selected.forEach(item => { selectedId.push(item.examTemplateQuestionsId) });
        this.$confirm('确认删除该题目？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;

  .edit {
    position: static;
    padding: 0;
    margin-left: 15px;
    font-size: 16px;
  }
}

/* 题目输入框样式 */
.title-input {
  display: inline;

  /deep/.el-input__inner {
    width: 200px !important;
  }
}

.detailswrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  /* 题目列表样式 */
  .el-table {
    border: 1px solid #e6e6e6;
    border-bottom: 0;

    .el-form {
      margin-left: 40px;

      .el-form-item {
        margin-bottom: 0;

        &.option {
          /deep/.el-form-item__content {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;

            div {
              width: 400px;
            }
          }
        }

        /deep/.el-form-item__content {
          font-size: 12px;
          line-height: 24px;
          padding-left: 72px;


        }

        /deep/.el-form-item__label {
          color: #999;
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
  }

  /* 题目模态框样式 */
  .questionsEdit {
    .option {
      .option-wrap {
        border: 1px solid #e6e6e6;
        padding: 0 7px;
        margin-bottom: 10px;

        .el-form-item {
          padding: 7px 0;
          margin: 0;

          &:not(:last-of-type) {
            border-bottom: 1px solid #e6e6e6;
          }

          /deep/.el-form-item__label {
            width: 60px !important;
          }

          /deep/.el-form-item__content {
            display: flex;

            .el-input {
              flex: 1;
              margin-right: 7px;
            }
          }
        }
      }
    }

    .el-form {
      .el-form-item {
        margin-right: 0;
        display: flex;

        /deep/.el-form-item__content {
          flex: 1;

          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>